import { useEffect } from 'react'
import { useLocation } from 'react-router'

/** Scrolls the window back to the top whenever the route changes. */
export const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    globalThis.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [pathname])

  return null
}
